"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KapiFetcher = void 0;
var react_1 = __importDefault(require("react"));
var kapi_1 = require("../../../../../shared/api/kapi");
var ui_1 = require("../ui");
var KapiFetcher = function (_a) {
    var _b, _c;
    var accountId = _a.accountId;
    var _d = (0, kapi_1.useAccountSummaryQuery)({
        variables: {
            accountId: accountId,
        },
    }), data = _d.data, loading = _d.loading, error = _d.error;
    if (error) {
        return react_1.default.createElement(ui_1.Error, null);
    }
    if (loading || !data) {
        return react_1.default.createElement(ui_1.Loading, null);
    }
    if (!((_c = (_b = data === null || data === void 0 ? void 0 : data.account) === null || _b === void 0 ? void 0 : _b.currentBalance) === null || _c === void 0 ? void 0 : _c.amount.value)) {
        return react_1.default.createElement(ui_1.Error, null);
    }
    return (react_1.default.createElement(ui_1.AccountSummaryUI, { balance: data.account.currentBalance.amount.value, accountNo: data.account.accountNo, latestBalanceDetails: null }));
};
exports.KapiFetcher = KapiFetcher;
